import React from 'react';
import { ErrorOutline } from '@material-ui/icons';
import { useTypedTranslation } from '@app/hooks';
import { Link } from '@material-ui/core';

interface IProps {
    isWarning: boolean;
    warningMessage: string;
    className?: string;
    errorType: string;
    onClick: () => void;
}
export const WarningBlock = ({ isWarning, warningMessage, className, errorType, onClick }: IProps) => {
    const { translation } = useTypedTranslation();

    return isWarning ? (
        <div className={`warning__block ${className}`}>
            <ErrorOutline className='warning__block-icon' />
            {warningMessage}
            {errorType === 'TIMEOUT' && <Link onClick={onClick}>{` ${translation('TRY_AGAIN')}`}</Link>}
        </div>
    ) : null;
};
